
import { CTAGeneric } from "@/components/cta";
import Tiles from "./tiles";
import { ScrollContainer } from "@/components/ui/scroll-container";
import ScrollIndicator from "@/components/ui/scroll-indicator";
import { Section } from "@/components/ui/section";
import { CTAWhyUs } from '@/components/cta';
import CTATestimonials from "@/components/cta/CTATestimonials";
import testimonials from "./testimonial.json";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import ContactFormSheet from "@/components/sliders/ContactFormSheet";


export default function Main() {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    return (
        <ScrollContainer snapType="y" snapBehavior="mandatory">
            {/* Hero Section */}
            <Section
                fullHeight={true}
                scrollSnap={true}
                variant="dark"
                backgroundImage="https://hncnzwww.blob.core.windows.net/www/img/sector/education-industry.webp"
                backgroundBlur={2}
                overlayOpacity={30}
                contentPosition="center"
                contained={false}
                padding="lg"
            >
                <div className="relative w-full h-full flex flex-col items-center justify-center">
                    {/* Floating decorative elements */}
                    <div className="absolute inset-0 pointer-events-none overflow-hidden">
                        <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-red-400 rounded-full animate-ping opacity-60"></div>
                        <div className="absolute top-1/3 right-1/3 w-1 h-1 bg-white rounded-full animate-pulse opacity-80"></div>
                        <div className="absolute bottom-1/3 left-1/5 w-1.5 h-1.5 bg-red-300 rounded-full animate-ping opacity-40 delay-1000"></div>
                        <div className="absolute top-1/2 right-1/4 w-1 h-1 bg-white rounded-full animate-pulse opacity-60 delay-500"></div>
                    </div>

                    {/* Main content with staggered animations */}
                    <div className="text-center text-white max-w-5xl w-full relative z-10">
                        {/* Badge with animation */}
                        {/* <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-8 animate-fade-in-up">
                            <div className="w-2 h-2 bg-red-400 rounded-full animate-pulse"></div>
                            <span className="text-sm font-medium text-white/90 uppercase tracking-wider">Education Solutions</span>
                        </div> */}

                        {/* Enhanced hero title with multiple effects */}
                        <h1 className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-7xl font-bold mb-6 sm:mb-8 md:mb-10 lg:mb-12 xl:mb-12 leading-none">
                            <div className="animate-fade-in-up delay-200">
                                <span className="inline-block text-white [text-shadow:2px_2px_4px_rgba(0,0,0,0.5)]">Schools and</span>
                            </div>
                            <div className="animate-fade-in-up delay-300 relative">

                                <span className="text-harvey-red relative [text-shadow:2px_2px_4px_rgba(0,0,0,0.5)]">
                                    Education
                                </span>
                                {/* Sparkle effects */}
                                <div className="absolute -top-2 -right-2 w-3 h-3">
                                    <div className="w-full h-full bg-yellow-300 rounded-full animate-ping opacity-75"></div>
                                </div>
                                <div className="absolute top-1/2 -left-4 w-2 h-2">
                                    <div className="w-full h-full bg-red-400 rounded-full animate-pulse opacity-80 delay-700"></div>
                                </div>
                            </div>
                        </h1>

                        {/* Enhanced subtitle with typewriter effect appearance */}
                        <div className="animate-fade-in-up delay-500">
                            <p className="text-base sm:text-lg md:text-xl lg:text-2xl mb-8 sm:mb-12 max-w-4xl mx-auto px-4 leading-relaxed">
                                <span className="text-white/90">Tailored solutions designed to </span>
                                <span className="text-white font-semibold">transform educational spaces</span>
                                <span className="text-white/90"> — from dynamic classrooms to efficient administrative offices.</span>
                            </p>
                        </div>

                        {/* Call-to-action buttons with hover effects */}
                        <div className="animate-fade-in-up delay-700 flex flex-col sm:flex-row gap-4 justify-center items-center mb-16">
                            <ContactFormSheet
                                buttonText={
                                    <span className="flex items-center gap-2 text-base font-semibold ">
                                        Contact Us
                                        <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                                        </svg>
                                    </span>
                                }
                                buttonClassName="btn max-w-[192px] whitespace-nowrap group bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white font-semibold px-10 py-7  rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
                            />
                            <a
                                href="tel:+64800222699"
                                className="btn max-w-[192px] whitespace-nowrap group bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white border border-white/30 hover:border-white/50 font-semibold px-8 py-4 rounded-full transition-all duration-300 transform hover:scale-105 inline-block"
                            >
                                <span className="flex items-center gap-2">
                                    0800 222 699
                                    <svg className="w-5 h-5 group-hover:rotate-12 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                    </svg>
                                </span>
                            </a>
                        </div>
                    </div>


                </div>
            </Section>


            <Section
                scrollSnap={true}
                variant="light"
                padding="xl"
                contained={false}
                overlayColor="transparent"
            >
                <div className="relative">
                    {/* Background decorative elements */}
                    <div className="absolute inset-0 overflow-hidden pointer-events-none">
                        <div className="absolute -top-24 -left-24 w-48 h-48 bg-gradient-to-br from-red-500/5 to-gray-900/5 rounded-full blur-3xl"></div>
                        <div className="absolute -bottom-12 -right-12 w-64 h-64 bg-gradient-to-tl from-red-600/3 to-gray-800/3 rounded-full blur-3xl"></div>
                    </div>

                    {/* Main content */}
                    <div className="relative z-10 text-center max-w-6xl mx-auto">
                        {/* Section badge */}
                        <div className="inline-flex items-center gap-2 bg-gradient-to-r from-red-50 to-gray-50 border border-red-100 rounded-full px-6 py-2 mb-8">
                            <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
                            <span className="text-sm font-medium text-gradient-red uppercase tracking-wider">How We Help</span>
                        </div>

                        {/* Main headline with gradient - combined messaging */}
                        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-8 leading-tight">
                            <span className="text-gray-900">We</span>{' '}
                            <span className="hero-text-gradient-red">
                                Transform
                            </span>

                            <span className="text-gray-900"> Learning Spaces</span>
                        </h2>

                        {/* Enhanced description */}
                        <div className="max-w-4xl mx-auto mb-12">
                            <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-6">
                                Harvey Norman Commercial NZ is your <span className="font-semibold text-gradient-red">trusted partner</span> for building smarter learning environments across New Zealand.
                            </p>
                            <p className="text-lg text-gray-600 leading-relaxed">
                                From early childhood to tertiary campuses, we deliver complete fit-out solutions — including classroom furniture, appliances, admin setups, and breakout areas. Our commercial-grade products and turn-key service help schools create learning spaces that balance performance and wellbeing.
                            </p>
                        </div>
                        {/* Call-to-action with scroll indicator */}
                        <div className="flex flex-col items-center">
                            <ScrollIndicator />
                        </div>
                    </div>
                </div>
            </Section>

            <Section
                scrollSnap={true}
                variant="default"
                padding="none"
                contained={false}
            >
                <Tiles />
            </Section>

            <Section
                scrollSnap={true}
                variant="default"
                padding="none"
                contained={false}
            >
                <CTATestimonials testimonials={testimonials} />
            </Section>

            <Section
                scrollSnap={true}
                variant="default"
                padding="none"
                contained={false}
            >
                <CTAWhyUs />
            </Section>

            <Section
                scrollSnap={true}
                variant="default"
                padding="none"
                contained={false}
            >
                <CTAGeneric title="Have a Question or Enquiry?" description="Let our business specialist help you. We are here to answer any questions you might have." />
            </Section>

        </ScrollContainer>
    );
}